import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, defer, from } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { AuthService } from "src/app/services/auth.service";
import { HTTP_CONTEXT_TOKEN_NO_TOKEN } from "src/app/core/http-context-tokens";

@Injectable()
export class AuthorizationTokenHeaderInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      req.url.startsWith("noauth::") ||
      req.url.startsWith("https://snoots-storage") ||
      req.url.indexOf("1ftcxqvb71") >= 0
    ) {
      return next.handle(
        req.clone({
          url: req.url.replace("noauth::", "")
        })
      );
    }

    if (req.context?.get(HTTP_CONTEXT_TOKEN_NO_TOKEN)) {
      return next.handle(req);
    }

    return from(
      defer(() => this.authService.getAuthorizationBearerToken())
    ).pipe(
      map((authorizationHeader) => {
        if (authorizationHeader) {
          return req.clone({
            headers: req.headers.set("Authorization", authorizationHeader)
          });
        }

        return req;
      }),
      switchMap((req) => next.handle(req))
    );
  }
}
